import { Component, OnInit } from '@angular/core';
import { User } from '../../core/classes/user';
import { AppConfigService } from 'src/app/app-config.service';
import RU from "../../../assets/i18n/RU.json";
import EN from "../../../assets/i18n/EN.json";
import { TranslateService } from '@ngx-translate/core';
import { PageMetaService } from "../../utils/page-meta/page-meta.service";

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
})
export class InstructionsComponent implements OnInit {
  user: User;
  isTraderActive: boolean = false;
  isWorkerActive: boolean = false;

  guide;
  guideElements;
  guideElementsForDisplay;
  selectedGuide: number;

  constructor(
    private config: AppConfigService,
    private pageMeta: PageMetaService,
    public translate: TranslateService,
  ) {
    this.guide = [
      {
        id: 1,
        title: 'Аккредитация',
        selected: true,
      },
      {
        id: 2,
        title: 'Торги',
        selected: false,
      },
      {
        id: 3,
        title: 'Персональный раздел',
        selected: false,
      },
      {
        id: 4,
        title: 'Электронные документы',
        selected: false,
      },
      {
        id: 5,
        title: 'Иное',
        selected: false,
      },
    ];

    this.guideElements = [
      {
        parentId: 1,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Аккредитация"',
        path: 'assets/UserGuide_PersonalPage(accreditation).pdf',
        size: '1.55 Mb',
        type: 'pdf',
      },
      {
        parentId: 1,
        forTrader: true,
        forWorker: true,
        name: 'Краткая инструкция по разделу "Аккредитация"',
        path: 'assets/UserGuide_PersonalPage(accreditation(short)).pdf',
        size: '390.32 Kb',
        type: 'pdf',
      },
      {
        parentId: 1,
        forTrader: true,
        forWorker: true,
        name: 'Краткая инструкция по разделу "Аккредитация (клиент брокера)"',
        path: 'assets/UserGuidePersonalPage(accreditation(client-docum)).pdf',
        size: '283.32 Kb',
        type: 'pdf',
      },
      {
        parentId: 1,
        forTrader: true,
        forWorker: true,
        name: 'Обучающий ролик по разделу "Аккредитация"',
        path: 'https://www.youtube.com/watch?v=4-ewLLTsGHA',
        size: '',
        type: 'video',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Краткая инструкция по работе в «Новой торговой системе» (для трейдера)',
        path: 'assets/UserGuide_NTS_(trader).pdf',
        size: '1.23 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Руководство пользователя «Общее описание единого биржевого пространства» (для трейдера)',
        path: 'assets/UserGuide_UAS_(trader).pdf',
        size: '3,30 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Руководство пользователя «Подсистема управления заявками» (для трейдера)',
        path: 'assets/UserGuide_OrderManagement_(trader).pdf',
        size: '2.18 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Руководство пользователя «Подсистема управления торгами_аукцион продавца (для трейдера)',
        path: 'assets/UserGuide_TradingSystem_Seller(trader).pdf',
        size: '2.75 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Руководство пользователя «Подсистема управления торгами_аукцион покупателя (для трейдера)',
        path: 'assets/UserGuide_TradingSystem_Buyer(trader).pdf',
        size: '2.61 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: false,
        forWorker: true,
        name: 'Краткая инструкция по работе_Новая торговая система (для работника)',
        path: 'assets/UserGuide_NTS(worker).pdf',
        size: '2.48 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: false,
        forWorker: true,
        name: 'Руководство пользователя_Единое биржевое пространство (для работника)',
        path: 'assets/UserGuide_EBP(worker).pdf',
        size: '7,93 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: false,
        forWorker: true,
        name: 'Руководство пользователя_Подсистема управления торгами_аукцион покупателя (для работника)',
        path: 'assets/UserGuide_TradingSystemBuyer(worker).pdf',
        size: '4.58 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: false,
        forWorker: true,
        name: 'Руководство пользователя_Подсистема управления торгами_аукцион продавца (для работника)',
        path: 'assets/UserGuide_TradingSystemSeller(worker).pdf',
        size: '4.98 Mb',
        type: 'pdf',
      },
      {
        parentId: 3,
        forTrader: true,
        forWorker: true,
        name: 'Общая инструкция для работы в приложении (для участника)',
        path: 'assets/UserGuide_PersonalPage(user).pdf',
        size: '1.24 Mb',
        type: 'pdf',
      },
      {
        parentId: 3,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Каталог товаров"',
        path: 'assets/UserGuide_PersonalPage(сatalog).pdf',
        size: '309.17 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Электронные документы"',
        path: 'assets/UserGuide_PersonalPage(electronicworkflow).pdf',
        size: '1.96 Mb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Краткая инструкция по разделу "Электронные документы"',
        path: 'assets/UserGuide_PersonalPage(electronicworkflow(short)).pdf',
        size: '485.84 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Краткая инструкция по разделу "Реестры"',
        path: 'assets/UserGuide_PersonalPage(reestrs(short)).pdf',
        size: '279.61 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Инфоподписки"',
        path: 'assets/UserGuide_PersonalPage(subscription).pdf',
        size: '141.58 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Допуск в торги"',
        path: 'assets/UserGuide_PersonalPage(admission).pdf',
        size: '216.92 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Контроль исполнения"',
        path: 'assets/UserGuide_PersonalPage(obligations).pdf',
        size: '466.63 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Финансовые документы"',
        path: 'assets/UserGuide_PersonalPage(financedocs).pdf',
        size: '625.13 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Обучающий ролик по электронному документообороту',
        path: `${this.config.ppUrl}/Content/static/pp_edu.mp4`,
        size: '',
        type: 'video',
      },
      {
        parentId: 5,
        forTrader: true,
        forWorker: true,
        name: 'Контакты отделов биржи',
        path: 'https://www.butb.by/kontakt-tsentr/kontakty/',
        size: '',
        type: 'link',
      },
      {
        parentId: 5,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по работе с ЭЦП',
        path: `${this.config.ppUrl}/UserGuide/HelpLoginDS`,
        size: '',
        type: 'link',
      },
    ];
  }

  private setBrowserTabInfo(): void {
    const LANDING_PAGE =
      this.translate.store.currentLang === 'RU'
        ? RU['general'].userManual
        : EN['general'].userManual;

    const faviconUrl = 'assets/img/icons/logo.svg';
    this.pageMeta.setPageMeta(null, LANDING_PAGE, faviconUrl);
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    this.setBrowserTabInfo();
    if (this.user?.IsWorker) {
      this.isTraderActive = false;
      this.isWorkerActive = true;

      this.guideElementsForDisplay = this.guideElements.filter((i) => {
        return i.forWorker === true && i.parentId == 1;
      });
    } else {
      this.isTraderActive = true;
      this.isWorkerActive = false;

      this.guideElementsForDisplay = this.guideElements.filter((i) => {
        return i.forTrader === true && i.parentId == 1;
      });
    }
  }

  viewDocs(type: string) {
    if (type == 'trader') {
      this.isTraderActive = true;
      this.isWorkerActive = false;
      //переключение имеет смысл только на вкладке ТОрги, остлаьные доки общие
      this.guideElementsForDisplay = this.guideElements.filter((i) => {
        return i.forWorker == false && i.forTrader == true;
      });
    }
    if (type == 'worker') {
      this.isWorkerActive = true;
      this.isTraderActive = false;
      this.guideElementsForDisplay = this.guideElements.filter((i) => {
        return i.forWorker == true && i.forTrader == false;
      });
    }
  }

  getGuideElementsToDisplay(parentId: number) {
    return this.guideElements.filter((it) => {
      if (parentId == 2) {
        if (!this.isTraderActive && !this.isWorkerActive) {
          return it.parentId == parentId && it.forTrader == false && it.forWorker == false;
        } else {
          return it.parentId == parentId && it.forTrader == this.isTraderActive && it.forWorker == this.isWorkerActive;
        }
      }

      return it.parentId === parentId;
    });
  }
}
